import { ApiUrl } from "../../../assets/data/TkApiUrlProperty";
import http from "../../../services/http";
import {
  IAPI_APP007_Request,
  IAPI_APP007_Response,
  IAPI_APP008_Request,
  IAPI_APP008_Response,
} from "../../../type/apiType";

// 共済契約対象外施設への異動情報参照
const httpAPI_APP007 = async (
  param: IAPI_APP007_Request
): Promise<IAPI_APP007_Response> => {
  const res = await http.post(ApiUrl.API_APP007, { ...param });

  return res.data;
};

// 共済契約対象外施設への異動情報更新
const httpAPI_APP008 = async (
  param: IAPI_APP008_Request
): Promise<IAPI_APP008_Response> => {
  let res = await http.post(ApiUrl.API_APP008, { ...param });

  return res.data;
};

export { httpAPI_APP007, httpAPI_APP008 };
